import React, { useState, useEffect } from "react";
import "./Staff.css";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

import DropDown from "../../Components/DropDown/DropDown";
import Input from "../../Components/Input/Input";
import Message from "../../Components/Message/Message";
import { useTranslation } from "react-i18next";

import { MdDeleteOutline } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { IoMdArrowDropdown, IoMdAdd } from "react-icons/io";
import { HiLockClosed } from "react-icons/hi";

import {
  get_all_staff,
  delete_staff,
  end_session,
} from "../../context/Services/Staff";

const Staff = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [staff, setStaff] = useState([]);
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(true);

  const handle_get_staff = () => {
    get_all_staff()
      .then((res) => {
        setStaff(res?.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handle_delete_staff = async (id) => {
    const willDelete = await swal({
      title: "Es-vous sûr ?",
      text: "Eest ce que vous voulez vraiment supprimer ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      delete_staff(id)
        .then((res) => {
          handle_get_staff();
          setTimeout(() => {
            setStatus(false);
          }, 1500);
        })
        .catch((e) => setStatus(false));
    }
  };

  const handle_end_session = async (id) => {
    const willDelete = await swal({
      title: "Es-vous sûr ?",
      text: "Est ce que vous voulez vraiment ferme les sessions ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      setStatus(true);

      end_session(id)
        .then((res) => {
          setTimeout(() => {
            setStatus(false);
          }, 1500);
        })
        .catch((e) => setStatus(false));
    }
  };

  const handle_navigate_stock = (id, action) => {
    window.open(`/staff/${id}?action=${action}`);
  };

  useEffect(() => {
    handle_get_staff();
  }, []);

  return (
    <>
      <Message loading={status} status={{ status: status }} />

      <div className="clients_overview latest_clients_overview shadow">
        <div className="chart_section_header flex items-center">
          <b>{t("Staff Overview")}</b>
          <div className="relative to-right flex gap">
            <div
              className="flex gap items-center filter_button"
              onClick={() => navigate("/add_staff")}
            >
              <IoMdAdd style={{ color: "#7983ff", fontSize: "1.2rem" }} />
              <b>{t("Ajouter Staff")}</b>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap summary_clients_section">
          <div className="flex gap_5 staff_sum">
            <div className="flex gap total_div ml_15 mt_-10">
              <p>{t("Total Staff")}:</p>
              <b>{staff?.length}</b>
            </div>
          </div>
          <div className="table_section table_section_overwrite">
            <table cellPadding="0" cellSpacing="0">
              <tbody>
                <td className="table-keys cell2 pointer">
                  {t("Nome et prenom")}
                </td>
                <td className="table-keys cell2 pointer">{t("Email")}</td>
                <td className="table-keys cell2 pointer">{t("Telephone")}</td>
                <td className="table-keys cell2 pointer">{t("Role")}</td>
                <td className="table-keys cell2 pointer">{t("Note")}</td>
                <td className="table-keys cell2 pointer">{t("Action")}</td>

                {staff?.map((elem, i) => (
                  <tr className={`data-cells`}>
                    <td className={`value2 cell2  `}>{elem?.full_name}</td>
                    <td className={`value2 cell2  `}>{elem?.email}</td>
                    <td className={`value2 cell2  `}>{elem?.telephone}</td>
                    <td className={`value2 cell2  `}>{elem?.role}</td>
                    <td className={`value2 cell2  `}>{elem?.note}</td>

                    <td className={`value2 cell2 action`}>
                      <div className="flex gap_5 justify-center">
                        <FaEye
                          className="action_btn view"
                          onClick={() =>
                            handle_navigate_stock(elem?._id, "readonly")
                          }
                        />
                        <MdDeleteOutline
                          className="action_btn delete"
                          onClick={() => handle_delete_staff(elem?._id)}
                        />
                        <AiOutlineEdit
                          className="action_btn edit"
                          onClick={() =>
                            handle_navigate_stock(elem?._id, "write")
                          }
                        />
                        <HiLockClosed
                          className="action_btn lock"
                          onClick={() => handle_end_session(elem?._id)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Staff;
